import { render, staticRenderFns } from "./DList.vue?vue&type=template&id=538477b4&"
import script from "./DList.vue?vue&type=script&lang=ts&"
export * from "./DList.vue?vue&type=script&lang=ts&"
import style0 from "./DList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports